
<div class="section section--bordered" id="top ">
  <div class="content">
    <div class="field field--small">
      <h3 class="section__caption" [innerHTML]=" content['section.caption'] ">
      </h3>
    </div>
  </div>
</div>
<div class="section">
  <div class="content">
    <div class="field">
      <div class="caption" [innerHTML]=" content['header.caption'] "></div>
      <h1 class="display" [innerHTML]=" content['header.display'] "></h1>
      <div class="copy" [innerHtml]="content['header.copy']"></div>
    </div>
  </div>
</div>
@for (faq of content['faqs']; track $index; let i = $index; let firstGroup = $first) {
  @let a = getIndex(firstGroup);
  <div #topic class="topic topic--{{i+1}}" [class.inactive]="!active[a]">
    <div class="section">
      <div class="content">
        <app-topic-head
          class="topic__head"
          [text]="faq.question"
          (click)="toggleActive(a)"
        ></app-topic-head>
        <div class="topic__content">
          <div
            class="answer"
            [innerHTML]="faq.answer"
          ></div>
        </div>
      </div>
    </div>

    @if (faq.tipp) {
      <div class="section section--light">
        <div class="content">
          <div class="field field--small">
            <app-tipp [content]="faq.tipp"></app-tipp>
          </div>
        </div>
      </div>
    }
    @if (faq.caption) {
      <div class="section section--bordered" >
        <div class="content">
          <div class="field field--small">
            <h3 class="section__caption" [innerHTML]="faq.caption"></h3>
          </div>
        </div>
      </div>
    }
    @for (child of faq.children; track $index; let j = $index; let firstItem = $first) {
      @let b = getIndex();

      <div
        #subtopic
        class="topic topic--{{i+1}}-{{j+1}}"
        [class.inactive]="!active[b]"
        >
        <div class="section">
          <div class="content content--inset">
            <app-topic-head
              class="topic__head"
              [text]="child.question"
              (click)="toggleActive(b)"
            ></app-topic-head>
            <div class="topic__content topic__content--inset">
              <div class="answer" [innerHTML]="child.answer"></div>
              @if (child.quote) {
                <div class="quote">
                  <p class="quote__text" [innerHTML]="child.quote.text"></p>
                  <p class="quote__author" [innerHTML]="child.quote.author"></p>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    }

  </div>
}
